import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";
import SoundManager from "Engine/soundManager/SoundManager";
import RelaxModel from "Base/model/RelaxModel";
import StatesManager from "Engine/base/states/StatesManager";

const paytableActionMap = {
    show: 'paytableShow',
    hide: 'paytableHide',
    switch: 'paytableClick',
}

export default class BaseUiMobilePortraitContainer extends FlashLib.MovieClip {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        this.init();
        this.addListeners();
        this.addActions();
    }

    init() {
        this.autoPlayPanel = this.getChildByName('autoPlayPanel');

        this.menuPopupContainer = this.getChildByName('menuPopupContainer');

        this.topPanel = this.getChildByName('topPanel');

        this.betContainer = this.getChildByName('betContainer');
        this.betContainer.setValue(EntryPoint.GameModel.totalBet);

        this.balanceContainer = this.getChildByName('balanceContainer');
        this.balanceContainer.setValue(EntryPoint.GameModel.balance);

        this.winContainer = this.topPanel.getChildByName('winContainer');
        this.winContainer.setValue(EntryPoint.GameModel.totalWin);

        this.totalWinContainer = this.topPanel.getChildByName('totalWinContainer');
        this.totalWinContainer.setValue(0);

        this.spinButton = this.getChildByName('spinButton');
        this.spinButton.enabled = true;

        this.soundButton = this.getChildByName('soundButton');
        this.soundButton.enabled = true;

        //this.autoPlayButton = this.getChildByName('autoPlayButton');
        //this.autoPlayButton.enabled = true;

        this.fastButton = this.getChildByName('fastButton');
        this.fastButton.enabled = RelaxModel.availableFastSpin;

        this.menuButton = this.getChildByName('menuButton');
        this.menuButton.enabled = true;

        this.homeButton = this.getChildByName('homeButton');
        this.homeButton.enabled = true;

        this.paytable = this.getChildByName('paytableContainer');

        this.soundButton.checked = EntryPoint.GameSettings.soundMute;
        this.fastButton.checked = EntryPoint.GameSettings.quickSpin;

        this.fastButton.visible = RelaxModel.availableFastSpin;
        this.autoPlayPanel.visible = RelaxModel.availableAutoPlayMobile;

        this.totalWinContainer.visible = (EntryPoint.GameModel.isFreeSpins || EntryPoint.GameModel.freeBets);
        this.winContainer.visible = !this.totalWinContainer.visible;
    }

    addListeners() {
        GlobalDispatcher.add('paytable:open', this.onOpenPaytable, this);
        GlobalDispatcher.add('paytable:closed', this.onPaytableClosed, this);
    }

    onGameResized(event) {
        let offset = (PIXI.utils.isMobile.apple.phone && event.params.canvasHeight > 2275) ? 150 : 0;
        this.y = event.params.canvasHeight - offset;
        this.topPanel.y = -(event.params.canvasHeight - (event.params.canvasHeight - this.y)) / this.scale.y;

        //this.topPanel.y = -event.params.canvasHeight / this.scale.y;

        this.paytable.y = -(event.params.canvasHeight - (event.params.canvasHeight - this.y)) / this.scale.y;
        this.paytable.resize({height:event.params.canvasHeight  / this.scale.y - Math.abs(this.menuPopupContainer.y)});

        //!!!
        //this.paytable.resize({height:this.height / this.scale.y - Math.abs(this.menuPopupContainer.y)});

        //this.paytable.resize({height:event.params.canvasHeight / this.scale.y - Math.abs(this.menuPopupContainer.y)});

        //this.paytable.y = -event.params.canvasHeight / this.scale.y;
        //this.paytable.resize({height:event.params.canvasHeight / this.scale.y - 180});
    }

    addActions() {
        this.spinButton.actions = {
            click: {
                callback: this.onSpinClick, context: this,
            },
            touchend: {
                callback: this.onSpinClick, context: this,
            }
        };
        this.menuButton.actions = {
            checked: {
                callback: this.onPaytableClick, context: this
            },
            unchecked: {
                callback: this.onPaytableClick, context: this
            }
        };
        this.fastButton.actions = {
            checked: {
                callback: this.onFastClick, context: this, params: true
            },
            unchecked: {
                callback: this.onFastClick, context: this, params: false
            }
        };
        this.soundButton.actions = {
            checked: {
                callback: this.onSoundClick, context: this, params: true
            },
            unchecked: {
                callback: this.onSoundClick, context: this, params: false
            }
        };
        this.homeButton.actions = {
            checked: {
                callback: this.onHomeClick, context: this, params: true
            },
            unchecked: {
                callback: this.onHomeClick, context: this, params: false
            }
        }
        /*this.autoPlayButton.actions = {
            checked: {
                callback: this.onAutoPlayButtonClick, context: this
            },
            unchecked: {
                callback: this.onAutoPlayButtonClick, context: this
            }
        };*/
    }

    onOpenPaytable(data) {
        const {params: {page, type}} = data;
        console.log('onOpenPaytable', data)

        this.menuPopupContainer[type]();
        GlobalDispatcher.dispatch(`ui:${paytableActionMap[type]}`);
        if (type === 'hide') {
            this.onPaytableClosed();
            return;
        }

        GlobalDispatcher.dispatch('paytable:goToPage', page === 'RULES' ? 3 : 1);
    }

    onFastClick(data) {
        EntryPoint.GameSettings.quickSpin = data;
    }

    onHomeClick(data) {
        let popupData = {
            message: 'label_leave_game_title',
            confirmCallback: RelaxModel.exitGame,
            confirmContext: RelaxModel,
            type: 'confirm'
        };
        GlobalDispatcher.dispatch('popupContainer:showPopup', popupData);
    }

    onSoundClick(data) {
        EntryPoint.GameSettings.soundMute = data;
        EntryPoint.GameSettings.musicMute = data;
    }

    onSpinClick() {
        switch (this.spinButton.contentState) {
            case 1:
                GlobalDispatcher.dispatch('ui:spinClick');
                break;
            case 2:
                EntryPoint.AutoPlaySettings.active = true;
                break;
            case 3:
                EntryPoint.AutoPlaySettings.active = false;
                break;
        }
    }

    onPaytableClick() {
        this.menuPopupContainer.switch();
        GlobalDispatcher.dispatch('ui:paytableClick');

        //this.spinButton.enabled = !this.menuButton.checked;
        //this.betContainer.enabled = !this.menuButton.checked;
        //this.autoPlayButton.enabled = !this.menuButton.checked;
        //this.fastButton.enabled = !this.menuButton.checked;

        //this.autoPlayPopupContainer.hide();
    }

    onOpenAutoPlayPanel() {
        //this.autoPlayPopupContainer.switch();
    }

    onAutoPlayButtonClick() {
        //this.autoPlayPopupContainer.switch();
        //GlobalDispatcher.dispatch('ui:changeAutoPlay');
    }

    onPaytableClosed(event) {
        this.menuButton.checked = false;
        this.menuPopupContainer.hide();
        this.spinButton.enabled = !this.menuButton.checked;
        this.betContainer.enabled = !this.menuButton.checked;
        this.autoPlayPanel.enabled = !this.menuButton.checked;
    }

    onSoundMute(event) {
        this.soundButton.checked = event.params;
    }

    onQuickSpin(event) {
        this.fastButton.checked = event.params;
    }

    onBetChanged(event) {
        if(EntryPoint.GameModel.freeBets) {
            return;
        }
        this.betContainer.setValue(event.params);
    }

    onBalanceChanged(event) {
        this.balanceContainer.setValue(event.params);
    }

    onAutoPlayChanged(event) {

    }

    onOverlayShowed(event) {
        this.popupOpened = true;

        //this.menuButton.enabled = false;
        this.spinButton.enabled = false;
        this.menuPopupContainer.hide();
        this.betContainer.enabled = false;
        this.autoPlayPanel.enabled = false;
    }

    onOverlayHided() {
        this.popupOpened = false;
        this.onStateChanged({params:StatesManager.currentState.stateData.name});
    }

    onStateChanged(event) {
        if (this.popupOpened) {
            return;
        }

        this.setWinContainer();

        switch (event.params) {
            case 'initState':

                break;
            case 'idleState':
                this.spinButton.enabled = true;
                this.autoPlayPanel.enabled = true;
                this.fastButton.enabled = RelaxModel.availableFastSpin;
                this.menuButton.enabled = true;

                if(EntryPoint.GameModel.freeBets) {
                    this.betContainer.enabled = false;
                } else {
                    this.betContainer.enabled = true;
                }

                if (EntryPoint.GameModel.baseSpin && !EntryPoint.GameModel.isFreeSpins && EntryPoint.GameModel.freeSpins && EntryPoint.GameModel.freeSpins.left === 0) {
                    this.winContainer.setValue(EntryPoint.GameModel.baseSpin.win/* + EntryPoint.GameModel.freeSpins.totalWin*/);
                    this.balanceContainer.setValue(EntryPoint.GameModel.balance);
                }
                break;
            case 'requestRollingState':
                //this.menuButton.enabled = false;
                this.spinButton.enabled = false;
                this.winContainer.setValue(0);
                //this.autoPlayPopupContainer.hide();
                this.menuPopupContainer.hide();
                this.betContainer.enabled = false;
                this.autoPlayPanel.enabled = false;
                break;
            case 'minimalRollingState':
                this.spinButton.enabled = RelaxModel.availableFastStop;
                break;
            case 'stopRollingState':
                this.spinButton.enabled = false;
                break;
            case'showWinningsState':
                this.winContainer.setValue(EntryPoint.GameModel.totalWin);

                if (!EntryPoint.GameModel.isFreeSpins || !EntryPoint.GameModel.freeBets) {
                    this.balanceContainer.setValue(EntryPoint.GameModel.balance);
                }
                if (EntryPoint.GameModel.freeSpins && EntryPoint.GameModel.freeSpins.played === 0) {
                    let balance = EntryPoint.GameModel.balance - (EntryPoint.GameModel.baseSpin.win || 0) + (EntryPoint.GameModel.totalWin || 0);
                    this.balanceContainer.setValue(balance);
                }

                this.updateTotalWinValue();
                break;
            case 'freeSpinsInState':
                this.spinButton.enabled = true;
                this.autoPlayPanel.enabled = false;
                this.betContainer.enabled = false;
                break;
            case 'freeSpinsOutState':
                this.spinButton.enabled = true;
                this.autoPlayPanel.enabled = false;
                this.betContainer.enabled = false;
                break;
            case 'showBigWinState':
                this.spinButton.enabled = false;
                this.autoPlayPanel.enabled = false;
                this.betContainer.enabled = false;
                this.winContainer.setValue(EntryPoint.GameModel.totalWin);

                if (!EntryPoint.GameModel.isFreeSpins) {
                    this.balanceContainer.setValue(EntryPoint.GameModel.balance);
                }
                if (EntryPoint.GameModel.freeSpins && EntryPoint.GameModel.freeSpins.played === 0) {
                    let balance = EntryPoint.GameModel.balance - (EntryPoint.GameModel.baseSpin.win || 0) + (EntryPoint.GameModel.totalWin || 0);
                    this.balanceContainer.setValue(balance);
                }

                this.updateTotalWinValue();
                break;
            default:
                this.spinButton.enabled = true;
                this.autoPlayPanel.enabled = true;
                break;
        }

        if (EntryPoint.GameModel.isFreeSpins) {
            this.betContainer.enabled = false;
            this.autoPlayPanel.enabled = false;
        }

        if (EntryPoint.GameModel.freeBets) {
            this.betContainer.enabled = false;
            this.autoPlayPanel.enabled = false;
        }
    }

    updateTotalWinValue() {
        let totalWinValue = 0;
        //if (EntryPoint.GameModel.freeBets) {
        if ((EntryPoint.GameModel.freeBets && EntryPoint.GameModel.freeBets.spins >= 0)) {
            totalWinValue = EntryPoint.GameModel.freeBets.win;
        }
        //if (EntryPoint.GameModel.isFreeSpins) {
        if (EntryPoint.GameModel.freeSpins && (EntryPoint.GameModel.freeSpins.played > 0 || EntryPoint.GameModel.freeSpins.played === EntryPoint.GameModel.freeSpins.total)) {
            totalWinValue = EntryPoint.GameModel.freeSpins.totalWin;
        }
        this.totalWinContainer.setValue(totalWinValue);
    }

    setWinContainer() {
        this.totalWinContainer.visible = false;
        this.winContainer.visible = true;

        if ((EntryPoint.GameModel.freeSpins && (EntryPoint.GameModel.freeSpins.played > 0 || EntryPoint.GameModel.freeSpins.played === EntryPoint.GameModel.freeSpins.total)) ||
            (EntryPoint.GameModel.freeBets && EntryPoint.GameModel.freeBets.spins >= 0)) {
            this.totalWinContainer.visible = true;
            this.winContainer.visible = false;
        }

        if (StatesManager.currentState.stateData.name === 'idleState' && !EntryPoint.GameModel.isFreeSpins && !EntryPoint.GameModel.freeBets) {
            this.totalWinContainer.visible = false;
            this.winContainer.visible = true;
        }
    }
}
